package com.macrofocus.eflux.ui.heatmap

import com.macrofocus.common.json.JsonArray
import js.objects.unsafeJso
import org.molap.dataframe.DataFrame

public fun createGeneratorHeatmapData(
    dataFrame: DataFrame<Int,String,Any?>,
    getCoordinates: (Int, DataFrame<Int, String, Any?>) -> JsonArray?
) : Array<dynamic> {
    val array = ArrayList<dynamic>()
    for(r in dataFrame.rows()) {
        val coordinates = getCoordinates(r, dataFrame)
        val amount = dataFrame.getValueAt(r, "qt") as Double?

        if(coordinates != null && amount != null) {
            val p = unsafeJso<dynamic> {
                COORDINATES = coordinates
                WEIGHT = amount
            }
            array.add(p)
        }
    }
    return array.toTypedArray()
}
